import { Routes } from "@angular/router";
import { mainViewComponent } from "./views/main-view/main-view.component";
import { mainViewComponentEmpresa } from "./views/main-view-empresa/main-view-empresa.component";
import { minorViewComponent } from "./views/minor-view/minor-view.component";
import { loginComponent } from "./views/login/login.component";
import { registerComponent } from "./views/register/register.component";
import { blankComponent } from "./components/common/layouts/blank.component";
import { basicComponent } from "./components/common/layouts/basic.component";
import { error404 } from "./components/common/errores/error404.component";
import { error500 } from "./components/common/errores/error500.component";
import { datosGenerales } from "./views/masivos/datosGenerales/datos-generales.component"
import { RenovacionVehiculo } from "./views/masivos/renovaciones/renovacion-vehiculo.component";
import { RenovacionOtrosRamos } from "./views/masivos/renovaciones/renovacion-otros-ramos.component";
import { RenovacionAsistenciaMedica } from "./views/masivos/renovaciones/renovacion-asistencia-medica.component";
import { RenovacionVivienda } from "./views/masivos/renovaciones/renovacion-vivienda.component";
import { SegurosContratados } from "./views/masivos/segurosContratados/seguros-contratados.component";
import { CancelacionBien } from "./views/masivos/cancelaciones/cancelacion.component";
import { ActivacionComponent } from "./views/register/activacion.component";
import { basicComponentEmpresa } from "./components/common/layouts/basic-empresa.component";
import { DatosGeneralesEmpresa } from "./views/empresas/datosGenerales/datos-generales-empresa.component";
import { EstadoDeCuenta } from "./views/empresas/estadoDeCuenta/estado-de-cuenta.component";
import { PolizasContratadas } from "./views/empresas/polizasContratadas/polizas-contratadas.component";
import { MovimientosComponent } from "./views/empresas/movimientos/movimientos.component";
import { AplicacionesTransporteComponent } from "./views/empresas/aplicacionesTransporte/aplicaciones-transporte.component";
import { AplicacionesTransporteConsultaComponent } from "./views/empresas/aplicacionesTransporte/aplicaciones-transporte-consulta.component";
import { Contactenos } from "./views/masivos/contactenos/contactenos.component";
import { DeclaracionesComponent } from "./views/empresas/declaraciones/declaraciones.component";
import { ExclusionEquipos } from "./views/empresas/solicitudes/solicitud-equipo.component";
import { ExclusionOtros } from "./views/empresas/solicitudes/solicitud-otros.component";
import { ExclusionVehiculos } from "./views/empresas/solicitudes/solicitud-vehiculos.component";
import { PolizasVencidasNoLiberadas } from "./views/empresas/fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.component";
import { Contragarantias } from "./views/empresas/fianzas/contragarantias/contragarantias.component";
import { AdministracionContactosComponent } from "./views/administracion-contactos/administracion-contactos.component";
import { Contratistas } from "./views/empresas/contratistas/contratistas.component";
import { vamTitulares } from "./views/vam/titulares/vam-titulares.component";
import { vamTitularesPolizas } from "./views/vam/polizas/vam-titulares-polizas.component";
import { vamImpuestoRenta } from "./views/vam/titulares/vam-impuestoRenta.component";
import { FormulariosComponent } from "./views/formularios/formularios.component";
import { cambiarContrasenaComponent } from "./views/login/cambiar-contrasena.component";
import { BoletinesComponent } from "./views/boletines/boletines.component";
import { ActasComponent } from "./views/actas/actas.component";
import { InformesComponent } from "./views/informes/informes.component";
import { ContratoSegurosComponent } from "./views/empresas/contratoSeguros/contrato-seguros.component";
import { SiniestrosComponent } from "./views/siniestros/siniestros.component";
import { SiniestralidadSiniestrosComponent } from "./views/siniestros/siniestralidad-siniestros.component";
import { RenunciaBeneficioSeguroComponent } from "./views/paginas_por_cliente/catolica_quito/renuncia-beneficio-seguro.component";
import { TerminosCondicionesComponent } from "./views/terminos_condiciones_app/term_cond.component";
import { siniestralidad } from "./views/empresas/polizasContratadas/siniestralidad.component";
import { siniestros } from "./views/empresas/polizasContratadas/siniestros.component";
import { loginMaestraComponent } from "./views/login/loginMaestra.component";
import { CancelarRenunciaBeneficioComponent } from "./views/register/CancelarRenunciaBeneficio.component";
import { ActasAccionistaComponent } from "./views/actasaccionista/actasaccionista.component";
import { SeguroscorporativosContratados} from "./views/masivos/vehiculoscorporativos/seguros-contratadoscorporativo.component";
import { SiniestroscorporarivoComponent } from "./views/siniestroscorporativos/siniestroscorporativos.component";
import { CitasAsesorVirtualComponent } from "./views/citas/citas-asesor-virtual.component";
import { detalleCredito } from "./views/empresas/seguroCredito/detalleCredito.component";
import { MovimientosVamComponent } from "./views/empresas/vamEmpresa/movimientos/movimientosVam.component";
import { ArquetipoComponent } from "./views/arquetipos/arquetipos.component";
import { EncuestaSaesComponent } from "./views/EncuetasSAES/EncuestaSaes.component";
import { MasivosVHComponent } from "./views/MasivoContratacion/MasivosVH.component";

export const ROUTES: Routes = [
  { path: '', redirectTo: 'login/1', pathMatch: 'full' },
  {
    path: '', component: basicComponent,
    children: [
      { path: 'mainView', component: mainViewComponent },
      { path: 'minorView', component: minorViewComponent }
    ]
  },
  {
    path: '', component: basicComponentEmpresa,
    children: [
      { path: 'mainViewEmpresa', component: mainViewComponentEmpresa },
      { path: 'datos-generales', component: DatosGeneralesEmpresa },
      { path: 'estado-de-cuenta', component: EstadoDeCuenta },
      { path: 'administracionContactos', component: AdministracionContactosComponent },
      { path: 'formularios', component: FormulariosComponent },
      { path: 'boletines', component: BoletinesComponent },
      { path: 'actas', component: ActasComponent },
      { path: 'informes', component: InformesComponent },
      // {
      //   path: 'siniestros',
      //   children: [
      //     { path: 'siniestralidad', component: SiniestralidadSiniestrosComponent },
      //     { path: 'detalle', component: SiniestrosComponent }
      //   ]
      // }
    ]
  },
  {
    path: '', component: basicComponent,
    children: [
      { path: 'acactasaccionistatas/:parcod', component: ActasAccionistaComponent },
      { path: 'formulariosMasivos', component: FormulariosComponent },
      { path: 'boletinesMasivos', component: BoletinesComponent }
      
    ]
  },
  {
    path: '', component: blankComponent,
    children: [
      { path: 'login/:bandera', component: loginComponent },
      { path: 'loginMaestra/:bandera/:cliente/:pass', component: loginMaestraComponent },
      { path: 'register/:bandera', component: registerComponent },
      { path: 'activacionUsuario/:codigo/:idUser', component: ActivacionComponent },
      { path: 'cambiar-contrasena/:bandera', component: cambiarContrasenaComponent },
      { path: 'terminosCondiciones', component: TerminosCondicionesComponent },
      { path: 'cancelarRenunciaBeneficio/:titular/:cliente/:ciudad', component: CancelarRenunciaBeneficioComponent },
      { path: 'arquetipo/:conclicod', component: ArquetipoComponent },
      { path: 'encuesta/:idsiniestro', component: EncuestaSaesComponent },
      { path: 'vh/:vehcod/:ciudad/:unidad', component: MasivosVHComponent }
    ]
  },
  {
    path: 'masivos', component: basicComponent,
    children: [
      { path: 'datos-generales', component: datosGenerales },
      {
        path: 'servicios',
        children: [
          { path: 'renovacion-vehiculos', component: RenovacionVehiculo },
          { path: 'renovacion-otros-ramos', component: RenovacionOtrosRamos },
          { path: 'renovacion-asistencia-medica', component: RenovacionAsistenciaMedica },
          { path: 'renovacion-vivienda', component: RenovacionVivienda },
          { path: 'seguros-contratados', component: SegurosContratados },
          { path: 'cancelacion-bienAsegurado', component: SegurosContratados },
          { path: 'renovacion-bienAsegurado', component: SegurosContratados }
        ]
      },
      { path: 'contactenos', component: Contactenos },
      { path: 'siniestros', component: SiniestrosComponent }
    ]
  },
  {
    path: 'vehiculocorporativo', component: basicComponent,
    children: [
      {
        path: 'servicios',
        children: [
          { path: 'seguros-contratadoscorporativo', component: SeguroscorporativosContratados }
        ]
      },
      { path: 'detallecorporativo', component: SiniestroscorporarivoComponent }
    ]
  },
  {
    path: 'VAM', component: basicComponent,
    children: [
      { path: 'datos-generales', component: vamTitulares },
      {
        path: 'servicios',
        children: [
          { path: 'polizas', component: vamTitularesPolizas },
          { path: 'renovacion-otros-ramos', component: RenovacionOtrosRamos },
        ]
      }, 
      { path: 'impuesto-renta', component: vamImpuestoRenta },
      { path: 'renunciaBeneficioMedico', component: RenunciaBeneficioSeguroComponent },
      { path: 'contactenos', component: Contactenos }
    ]
  },
  {
    path: 'patrimoniales', component: basicComponentEmpresa,
    children: [
      {
        path: 'consultas',
        children: [
          { path: 'polizas', component: PolizasContratadas },
          { path: 'siniestralidad', component: minorViewComponent },
          //{ path: 'siniestros', component: minorViewComponent },
          { path: 'resumen-movimientos', component: MovimientosComponent },
          { path: 'resumen-aplicaciones-transporte', component: AplicacionesTransporteComponent },
          { path: 'documentos-interes', component: minorViewComponent },
          { path: 'contratistas', component: Contratistas }
        ]
      },
      {
        path: "solicitudes",
        children: [
          { path: 'movimientos', component: PolizasContratadas },
          { path: 'declaraciones', component: DeclaracionesComponent },
          { path: 'aplicaciones-transporte', component: AplicacionesTransporteConsultaComponent },
        ]
      },
      {
        path: 'siniestros',
        children: [
          { path: 'siniestralidad', component: SiniestralidadSiniestrosComponent },
          { path: 'detalle', component: SiniestrosComponent }
        ]
      }
      ,
      { path: "formularios", component: minorViewComponent }
    ]
  },
  {
    path: 'pymes', component: basicComponentEmpresa,
    children: [
      {
        path: 'consultas',
        children: [
          { path: 'polizas', component: PolizasContratadas },
          { path: 'siniestralidad', component: minorViewComponent },
          //{ path: 'siniestros', component: minorViewComponent },
          { path: 'resumen-movimientos', component: MovimientosComponent },
          { path: 'resumen-aplicaciones-transporte', component: AplicacionesTransporteComponent },
          { path: 'documentos-interes', component: minorViewComponent },
          { path: 'contratistaspymes', component: Contratistas }
        ]
      },
      {
        path: "solicitudes",
        children: [
          { path: 'movimientos', component: PolizasContratadas },
          { path: 'declaraciones', component: DeclaracionesComponent },
          { path: 'aplicaciones-transporte', component: AplicacionesTransporteConsultaComponent },
        ]
      },
      { path: "formularios", component: minorViewComponent }
    ]
  },
  {
    path: 'fianzas', component: basicComponentEmpresa,
    children: [
      {
        path: 'consultas',
        children: [
          { path: 'polizas', component: PolizasContratadas },
          { path: 'documentos-interes', component: minorViewComponent },
          { path: 'contragarantias', component: Contragarantias },
          { path: 'polizasVencidas', component: PolizasVencidasNoLiberadas },
          { path: 'cupos', component: minorViewComponent },
          { path: 'contrato-seguros', component: ContratoSegurosComponent },
        ]
      },
      { path: "formularios", component: minorViewComponent }
    ]
  },
  {
    path: 'credito', component: basicComponentEmpresa,
    children: [
      {
        path: 'consultas',
        children: [
          { path: 'polizas', component: PolizasContratadas },
          { path: 'siniestralidad', component: minorViewComponent },
          //{ path: 'siniestros', component: minorViewComponent },
          { path: 'documentos-interes', component: minorViewComponent },
          { path: "detalleCredito", component: detalleCredito }
        ]
      },
      { path: "formularios", component: minorViewComponent }
    ]
  },
  {
    path: 'VAM', component: basicComponentEmpresa,
    children: [
      {
        path: 'consultas',
        children: [
          { path: 'polizas', component: PolizasContratadas },
          { path: 'reportes-estadisticos', component: minorViewComponent },
          { path: 'siniestros', component: siniestros },
          { path: 'movimientos', component: MovimientosVamComponent },
          { path: 'documentos-interes', component: minorViewComponent },
          { path: 'redes', component: minorViewComponent },
          { path: 'siniestralidad', component: siniestralidad }
        ]
      },
      { path: "formularios", component: minorViewComponent }
    ]
  },
  {
    path: '',
    component: basicComponent,
    children: [
      {path: 'citas-asesor-virtual', component: CitasAsesorVirtualComponent}
    ]
  },
  {
    path: 'error', component: blankComponent,
    children: [
      { path: '404', component: error404 }
    ]
  },
  {
    path: 'error', component: basicComponent,
    children: [
      { path: '500', component: error500 }
    ]
  },
  { path: '**', redirectTo: "/error/404" }
];



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/app.routes.ts